import {
	IonContent,
	IonPage,
	IonButton,
	IonInput,
	IonLabel,
	IonItem,
} from "@ionic/react";
import React, { useEffect, useState } from "react";

import { Link, useHistory } from "react-router-dom";
import { toast } from "../../../components/Toast/toast";
import { sendPasswordReset } from "../../../services/auth";
import { connect } from "react-redux";
import { setLoading } from "../../../services/loading";
import Spacer from "../../../components/spacer";

interface Props {
	setLoading: any;
	loggedIn: any;
}

const ForgotPassword: React.FC<Props> = ({ setLoading, loggedIn }) => {
	const history = useHistory();
	const [email, setEmail] = useState("");
	const [error, setError] = useState("");

	useEffect(() => {
		if (loggedIn) {
			history.replace("/");
		}
		//eslint-disable-next-line
	}, [loggedIn]);

	const _onChange = (e: any) => {
		setError("");
		setEmail(e.target.value);
	};

	const _resetPassword = () => {
		setLoading(true, "Please wait...");
		sendPasswordReset(email)
			.then((res: any) => {
				if (res) {
					history.replace("/login");
					toast("Password reset email sent! Please check your inbox", 4000);
				}
			})
			.catch((error: any) => {
				if (error.code === "auth/invalid-email") {
					setError("Please check your email address. It doesn't seem right.");
				}
			});
		setLoading(false);
	};

	if (!loggedIn)
		return (
			<IonPage>
				<IonContent fullscreen className="ion-padding auth-screen">
					<div className="page-wrapper app-background">
						<div id="app-logo" />
						<div id="content-box">
							<h1 className="center-text">Forgot Your Password?</h1>
							<p className="center-text instructions">
								Request a password reset email
							</p>
							<IonItem>
								<IonLabel position="floating">Your Email</IonLabel>
								<IonInput
									type="email"
									placeholder="Email"
									onIonChange={_onChange}
								/>
							</IonItem>
							{error && <p className="center-text error-message">{error}</p>}
							<Spacer size="15" />
							<IonButton expand="full" size="large" onClick={_resetPassword}>
								Reset Your Password
							</IonButton>
							<Spacer size="15" />
							{/* <p
								onClick={() => history.push("/")}
								className="linked instructions small center-text"
							>
								Go back
							</p> */}
							<Link
								to="/"
								className="instructions small full-width center-text"
							>
								Go Back
							</Link>
						</div>
					</div>
				</IonContent>
			</IonPage>
		);
	else return null;
};

const mapStateToProps = (state: any) => ({
	loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, { setLoading })(ForgotPassword);
